module.exports = __webpack_public_path__ + "static/media/service-07.7c630b4f.webm";